export default "__VITE_ASSET__c068836a__"